import React, { useState } from 'react'
import {
  Ellipse,
  Section,
  TimelineAccordionContainer,
  TimelineAccordionContent,
  TimelineAccordionTitle,
  VerticalLine
} from './styles'
import { IconComponent } from '~/assets/icons/component'

export interface TimelineYearsAccordionProps {
  title: string
  content: React.ReactNode
  startOpen?: boolean
  active?: boolean
}

export const TimelineYearsAccordion = ({
  content,
  title,
  startOpen = true,
  active
}: TimelineYearsAccordionProps): JSX.Element => {
  const [accordionIsOpen, setAccordionIsOpen] = useState(startOpen)

  const toggleValue = (value: boolean) => !value

  const handleOpenAccordion = () => {
    setAccordionIsOpen(toggleValue)
  }

  return (
    <TimelineAccordionContainer>
      <Section marginTop={5}>
        <VerticalLine />
        <Ellipse className={`${active ? 'filled' : 'outlined'}`} />
      </Section>

      <Section>
        <TimelineAccordionTitle onClick={handleOpenAccordion} isOpen={accordionIsOpen}>
          {title} <IconComponent name="chevronRight" />
        </TimelineAccordionTitle>
        <TimelineAccordionContent isOpen={accordionIsOpen}>{content}</TimelineAccordionContent>
      </Section>
    </TimelineAccordionContainer>
  )
}
